import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse'
import SingleSelectedImageCaptcha from './SingleSelectedImageCaptcha';


class SingleSelectImageResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: 0,
            isSelect: false,
            responseValue: '',
            acceptComment: null,
            tempVal: '',
            images:[],
            selectAllChecked: false
        };

        this.isUpdateResponse = false;
        this.reviewPage = this.props.questionItemList || [];
        this.itemCollection = [];
        // this.onSelectImage = this.onSelectImage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.isGetAllUpdate !== true) {
            const { getAllItemResponse, items, singleSelectImageItemConfiguration, getAllItemResponseForMultiple, rateeKey, putAllForItemCollection } = nextProps;
            const { itemResponseSets } = getAllItemResponse;

            for (const key in getAllItemResponseForMultiple) {
                this.isUpdateResponse = true;

                if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                    const elementRes = getAllItemResponseForMultiple[key];

                    if (rateeKey !== undefined && key === rateeKey) {
                        const { itemResponseSets } = elementRes;
                        for (const key in itemResponseSets) {
                            this.isGetAllUpdate = true;

                            if (itemResponseSets.hasOwnProperty(key)) {
                                const element = itemResponseSets[key];
                                const tempItemResponseSets = itemResponseSets[key];

                                if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                    var itemResponsesObj = element.itemResponses.length > 0 ? element.itemResponses : element.demographicResponses.length > 0 ? element.demographicResponses : []
                                    this.reviewPage[items.key][0].userResponse = itemResponsesObj;

                                    itemResponsesObj.forEach(item => {

                                        if (item.response !== null && this.state.isSelect === false) {
                                            this.setState({
                                                isSelect: true,
                                                responseValue: item.response,
                                                // acceptComment:item.openEnd
                                            });

                                            this.state.images.filter((items) => {
                                                if (items.response === item.response) {
                                                    items.isSelected = true
                                                }
                                            })
                                        }
                                    });

                                    for (const key in tempItemResponseSets.itemResponses) {
                                        if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                            const temp = tempItemResponseSets.itemResponses[key];
                                            const itemList = this.reviewPage[items.reviewPageKey];

                                            for (const key in itemList) {
                                                if (itemList.hasOwnProperty(key)) {
                                                    const itemRes = itemList[key];
                                                    var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses : [];
                                                    this.sequenceCount = itemResponseArr.length + 1;

                                                    if (temp.response !== null && this.state.isSelect === false) {
                                                        itemRes.isAnswer = temp.responseValue !== null ? true : false;
                                                        itemRes.isRequired = false;
                                                        itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;

                                                        var itemType = singleSelectImageItemConfiguration.itemType;
                                                        var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
                                                        processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { responseValue } = this.state;
        const { configuration } = this.props;
        var defaultImg = "https://www.gemkom.com.tr/wp-content/uploads/2020/02/NO_IMG_600x600-1.png";

        configuration && configuration !== undefined && configuration.map((item) => {
            item.src = item.responseImageUrl !== "" ? item.responseImageUrl : defaultImg
            item.thumbnail = item.responseImageUrl !== "" ? item.responseImageUrl : defaultImg
            item.isSelected = false
            item.thumbnailCaption = (<span className="title" dangerouslySetInnerHTML={{ __html: item.responseDescription }}></span>)
        });

        this.setState({ images: configuration });
        this.handleSkipPage(responseValue);
    }


    handleChange = (event, configuration, rateeKey, index, type) => {
        try {
            const { items, handleItemResponse, singleSelectImageItemConfiguration, itemProperties, itemTempResponses, ratees, putAllForItemCollection } = this.props;
            const { responseDescription, response, responseValue } =
              configuration;
            var acceptComment = type === "input" ? event.target.value : null;

            this.setState({
                active: configuration.responseValue,
                isSelect: true,
                responseValue: items.isReversePolarity ? configuration.reversePolarityResponseValue : configuration.responseValue,
                acceptComment: acceptComment
            });

            let setResponseValue = items.isReversePolarity ? configuration.reversePolarityResponseValue : configuration.responseValue;
            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {
                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];;
                    var itemKey = itemList[key].key;


                    if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {
                        for (const rKey in ratees) {
                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {

                                    var resValue = this.state.images[index].isSelected ? 1 : null;
                                    itemList[key].isAnswer = resValue !== null ? true : false;

                                    if (itemList[key].requiredIndicator == 2) {
										itemList[key].isRequired = itemList[key].isAnswer == true ? false : true;
									} else {
                                        itemList[key].isRequired = false
                                    }

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType": singleSelectImageItemConfiguration.itemType,
                                        "buttonGroup": null,
                                        "sequence": this.sequenceCount++,
                                        "isNa": itemList[key].isNA,
                                        "response": response,
                                        "responseValue": setResponseValue,
                                        "openEnd": acceptComment,
                                        "responseDescription": responseDescription
                                    }];

                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].itemResponses[itemKey];
                                    var itemType = singleSelectImageItemConfiguration.itemType;

                                    processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                }
                            }
                        }
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                }
            }
            handleItemResponse(items.key, itemTempResponses, "itemChange", rateeKey);

        } catch (error) {
            console.log("Exception: while responding question answer in multi select response:_", error);
        }
    }


    handleSkipPage = (tempResponseValue) => {
        try {
            const { dependencies, items, pageList, pageNumber, activePageKey, survey } = this.props;
            var count = 0;
            var itemCount = 0;

            var responseValue = tempResponseValue

            for (const key in dependencies) {
                if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key];

                    element.filter((dep) => {
                        if (dep.dependsOnKey === items.key) {

                            for (const key in pageList) {
                                if (Object.hasOwnProperty.call(pageList, key)) {
                                    const tempItems = pageList[key];

                                    tempItems.items.filter((itm) => {
                                        if (itm.key === dep.key && itm.hasDepend) {
                                            itemCount = tempItems.items.length
                                            count++;
                                        }
                                    });

                                }
                            }

                            var skipDiv = document.getElementById("survey-item-block_" + dep.key);
                            var tempConditionsString = "";

                            if (element.length > 1) {
                                element.reduce((a, b) => {
                                    tempConditionsString = `(${a.response} ${a.booleanOperator} ${responseValue}) ${a.dependsOnConditionalOperator == null ? b.dependsOnConditionalOperator == null ? a.key === b.key ? '||' : '&&' : b.dependsOnConditionalOperator : a.dependsOnConditionalOperator} (${responseValue} ${b.booleanOperator} ${b.response})`
                                })
                            } else {
                                tempConditionsString = `${dep.response} ${dep.booleanOperator} ${tempResponseValue}`;
                            }

                            if (tempConditionsString !== '' && eval(tempConditionsString)) {
                                this.handleDependencyRequired(dep.key, "block");
                                survey.pages[pageNumber].isSkipPage = false;
                                skipDiv.style.display = "block";

                            } else {
                                this.handleDependencyRequired(dep.key, "none")
                                survey.pages[pageNumber].isSkipPage = (count === itemCount ? true : false);
                                skipDiv.style.display = "none";
                            }
                        }
                    })
                }
            }
        } catch (error) {
            // console.log("Exceptions: while skipping item and page", error.message);
        }
    }

    handleDependencyRequired = (dependentKey, type) => {
        try {
            const { pageList } = this.props;
            const surveyObj = pageList;

            for (const key in surveyObj) {
                if (Object.hasOwnProperty.call(surveyObj, key)) {
                    const tempItems = surveyObj[key].items;

                    for (const key in tempItems) {
                        if (Object.hasOwnProperty.call(tempItems, key)) {
                            const element = tempItems[key];

                            if (element.key === dependentKey && element.hasDepend && type === "block") {
                                element.isRequired = element.requiredIndicator === 2 && element.isAnswer === false ? true : false;
                            }

                            if (element.key === dependentKey && element.hasDepend && type === "none") {
                                element.isRequired = false;
                            }
                        }
                    }
                }
            }
        } catch (error) {

        }
    }


    handelImageSelection = (index, image) => {

        var images = this.state.images;
        var img = images[index];

        if (img.hasOwnProperty("isSelected")) {
            images.filter((item) => {
                if (item.response == img.response) {
                    item.isSelected = true;
                } else {
                    item.isSelected = false;
                }
            })

        } else {
            // img.isSelected = true;
        }

        this.setState({
            images: images
        });

        this.handleChange(null, img, this.props.rateeKey, index, "type");
    }

    handleImageClick = (index) => {
		this.handelImageSelection(index);
	}


    render() {
        const { configuration, suppressLabel, id, rateeKey, items, itemKey, className, indexKey } = this.props;
        return (
            <Fragment>
                <Row>
                    <Col xs={12} key={itemKey} className={`_LIS_SingleSelect`}>
                        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePreSection) }}></div> : null}
                        <Col col={10}>
                            <SingleSelectedImageCaptcha
				       		image={this.state.images} 
            				handleChange={this.handleChange}
							rateeKey={this.props.rateeKey}
          				/>
                        </Col>
                        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePreSection) }}></div> : null}
                    </Col>
                </Row>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount: state.survey.answeredQuestionCount,
    getAllItemResponse: state.survey.getAllItemResponse,
    getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple
})

export default connect(mapStateToProps)(SingleSelectImageResponse);
